import React, { FC, useRef } from 'react';
import { Button } from '../Button';

type Props = {
    text: string;
    onPickFile: (file: File) => void;
    accept?: string;
};

export const FilePickerButton: FC<Props> = ({ text, onPickFile, accept = 'image/*' }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const openFileDialog = () => {
        inputRef.current?.click();
    };

    const onChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
        const file = e.target.files?.[0];
        if (!file) return;

        onPickFile(file);

        // allow selecting the same file again
        e.target.value = '';
    };

    return (
        <>
            <input
                ref={inputRef}
                type="file"
                accept={accept}
                onChange={onChange}
                style={{ display: 'none' }}
            />

            <Button onClick={openFileDialog} text={text} />
        </>
    );
};
